import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-registration-prompt',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="prompt-dialog">
      <div class="prompt-header">
        <h2 mat-dialog-title>Complete Your Registration</h2>
        <button mat-icon-button (click)="onSkip()" class="close-btn">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      
      <mat-dialog-content class="prompt-content">
        <div class="icon-wrapper">
          <mat-icon class="main-icon">assignment</mat-icon>
        </div>
        <p class="prompt-message">
          Would you like to complete your patient registration form now? 
          This will help us serve you better during your visit.
        </p>
        <p class="prompt-sub-message">
          You can also complete this later from your dashboard.
        </p>
      </mat-dialog-content>
      
      <mat-dialog-actions class="prompt-actions">
        <button mat-stroked-button (click)="onSkip()" class="skip-btn">
          Skip for now
        </button>
        <button mat-raised-button color="primary" (click)="onFill()" class="fill-btn">
          Fill out form
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .prompt-dialog {
      padding: 0;
    }
    
    .prompt-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 24px 0;
    }
    
    .prompt-header h2 {
      margin: 0;
      font-size: 20px;
      font-weight: 500;
    }
    
    .close-btn {
      position: absolute;
      top: 8px;
      right: 8px;
    }
    
    .prompt-content {
      padding: 20px 24px !important;
      text-align: center;
      max-width: 450px;
    }
    
    .icon-wrapper {
      margin-bottom: 20px;
    }
    
    .main-icon {
      font-size: 64px;
      width: 64px;
      height: 64px;
      color: #1976d2;
    }
    
    .prompt-message {
      font-size: 16px;
      color: #212121;
      margin-bottom: 12px;
      line-height: 1.5;
    }
    
    .prompt-sub-message {
      font-size: 14px;
      color: #666;
      margin: 0;
    }
    
    .prompt-actions {
      padding: 20px 24px !important;
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      border-top: 1px solid #e0e0e0;
    }
    
    .skip-btn {
      color: #666;
    }
    
    .fill-btn {
      min-width: 120px;
    }
  `]
})
export class RegistrationPromptComponent {
  constructor(
    public dialogRef: MatDialogRef<RegistrationPromptComponent>
  ) {}

  onSkip(): void {
    this.dialogRef.close('skip');
  }

  onFill(): void {
    this.dialogRef.close('fill');
  }
}